import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué hago si mi depresión no mejora ni con medicación?",
    answer:
      "Puede tener depresión resistente al tratamiento, que afecta a aproximadamente un tercio de las personas tratadas por trastorno depresivo mayor. Las opciones incluyen ajustes de medicación, TMS, SAINT® TMS acelerada y SPRAVATO®. Una evaluación psiquiátrica puede identificar los siguientes pasos.",
  },
  {
    question: "¿La TMS ayuda cuando la medicación no funciona?",
    answer:
      "Sí. La TMS está autorizada por la FDA para la depresión que no ha respondido a medicación. SAINT® es un protocolo de TMS acelerada de cinco días autorizado por la FDA (K220177).",
  },
];

export const esDepressionWontGoAway = makeEsArticle({
  slug: "depression-wont-go-away-even-with-medication",
  title: "La depresión no se va ni con medicación | Neuro Wellness",
  description:
    "Si la depresión no mejora ni con medicación, puede ser resistente al tratamiento. Opciones como TMS, SAINT® y SPRAVATO® actúan por mecanismos distintos a los antidepresivos.",
  h1: "La depresión no se va ni con medicación",
  breadcrumbLabel: "La depresión no se va",
  shortAnswer:
    "Si la depresión no mejora ni con medicación, puede tener depresión resistente al tratamiento, que afecta a aproximadamente un tercio de las personas tratadas por trastorno depresivo mayor. No es el final del camino: existen opciones que actúan por mecanismos distintos a los antidepresivos orales —TMS, SAINT® TMS acelerada y SPRAVATO®. Una evaluación psiquiátrica puede identificar los siguientes pasos.",
  keyTakeaways: [
    "La depresión que no mejora con medicación puede ser resistente al tratamiento.",
    "Afecta a ~1/3 de los tratados.",
    "TMS, SAINT® y SPRAVATO® actúan por mecanismos distintos.",
    "Una evaluación psiquiátrica identifica los siguientes pasos.",
  ],
  sections: [
    {
      heading: "Por qué no se va",
      paragraphs: [
        "La depresión que persiste a pesar de la medicación puede deberse a dosis inadecuada, medicamento no adecuado, error diagnóstico o depresión resistente al tratamiento. Aproximadamente un tercio de las personas tratadas por trastorno depresivo mayor no alcanzan la remisión tras dos pasos de tratamiento.",
      ],
    },
    {
      heading: "Opciones que actúan de forma distinta",
      paragraphs: [
        "La TMS está autorizada por la FDA para la depresión que no ha respondido a medicación. SAINT® es un protocolo de TMS acelerada de cinco días autorizado por la FDA (K220177). SPRAVATO® está aprobado por la FDA para la depresión resistente al tratamiento. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
